import React from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import BadgeUI from '../../../widgets/output/BadgeUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import Icon from '@sendbird/uikit-react/ui/Icon'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import TxnsLoanBalanceModalSF from '../virtualTxn/TxnsLoanBalanceModalSF'

const SuTransactionInnerListUI = ({ context, txnList, account,
  onCopyToClipboard, copyToClipboardText, details, onDetailsClick,
  onTransactionTypeUpdateClick, onUpdateLoanBalanceClick, caller, creditSum, debitSum
}) => {
  const visibleTxnList = (txnList || []).filter(txn =>
    account && (
      (account.testAccount && txn.testAccount) ||
      (!account.testAccount && !txn.testAccount)
    )
  )

  return (
  <div className='txns'>
    {
      visibleTxnList.length > 0 &&
      <div className='g_flex_h'>
        <span>{visibleTxnList.length} transaction{visibleTxnList.length === 1 ? '' : 's'} displayed</span>
      </div>
    }

    <table>
      <thead className='g_small'>
        <tr>
          {caller === 'dailyTxnList' && <th>S no.</th>}
          <th>Date</th>
          <th>Details</th>
          <th>Credit</th>
          <th>Debit</th>
          {caller !== 'dailyTxnList' && <th>Balance</th>}
        </tr>
      </thead>
      <tbody>
        {
          visibleTxnList.map((txn, i) =>
            <TxnRowUI2 key={txn.transactionId || i} i={i} context={context} txn={txn}
              onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
              details={details} onDetailsClick={onDetailsClick} onTransactionTypeUpdateClick={onTransactionTypeUpdateClick}
              onUpdateLoanBalanceClick={onUpdateLoanBalanceClick} caller={caller} creditSum={creditSum} debitSum={debitSum}
            />
          )
        }
        {
          caller === 'dailyTxnList' &&
          <tr>
            <td><b>Totals</b></td>
            <td></td>
            <td></td>
            <td><b>{creditSum}</b></td>
            <td style={{ padding: '16px' }}><b>{debitSum}</b></td>
            <td></td>
          </tr>
        }
      </tbody>
    </table>
    {
      visibleTxnList.length === 0 &&
      <EmptyListUI
        context={context}
        createDisabledMessageLabel='No transactions'
      />
    }
  </div>
  )
}

const TxnRowUI2 = ({ context, txn, i, onCopyToClipboard, copyToClipboardText, details, onDetailsClick, onTransactionTypeUpdateClick,
  onUpdateLoanBalanceClick, caller, creditSum, debitsum
}) =>
  <tr className='g_small'>
    {
      caller === 'dailyTxnList' &&
      <td className='g_text_top g_small'>{i + 1}.</td>
    }
    <td className='g_text_top g_small'>
      <span className='g_no_wrap_2'>{txn.transactionDateF}</span>
    </td>
    <td className='g_text_top g_p_left_50 g_small'>
      <RowLeftUI txn={txn}
        onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
        details={details} onDetailsClick={onDetailsClick} onTransactionTypeUpdateClick={onTransactionTypeUpdateClick}
      />
    </td>
    <td className='g_text_top g_text_right g_p_left_50 g_small'>
      {
        txn.amount >= 0 &&
        <span>{txn.amountF1}</span>
      }
    </td>
    <td className='g_text_top g_text_right g_p_left_50 g_small'>
      {
        txn.amount < 0 &&
        <span>({txn.amountF1})</span>
      }
      {
        details && txn.interestF1 &&
        <span className='g_muted'><br />{txn.interestF1}<br />{txn.principalF1}<br />{txn.scheduledDateISO}</span>
      }
      {
        txn.status === 'pending' &&
        <div className='g_m_top_25'>
          <BadgeUI label={txn.status} />
        </div>
      }
    </td>
    {caller !== 'dailyTxnList' &&
      <td className='g_text_top g_text_right g_p_left_50 g_small'>
        {txn.runningBalance < 0 ? `(${txn.runningBalanceF1})` : txn.runningBalanceF1}
      </td>
    }
    {
      onUpdateLoanBalanceClick &&
      <td>
        <span className='icon icon-pencil g_muted g_m_left_50' onClick={onUpdateLoanBalanceClick} data-id={txn.transactionId} />
      </td>
    }
  </tr>

const RowLeftUI = ({ txn, onCopyToClipboard, copyToClipboardText, details, onTransactionTypeUpdateClick }) =>
  <div className='g_flex_v'>
    {
      txn.narration &&
      <span className='g_small'>{txn.narration}</span>
    }
    {
      details &&
      <span className=''>
        <span className='g_muted'>{txn.transactionId}</span>
        <span onClick={e => e.stopPropagation()}>
          <CopyToClipboard text={txn.transactionId}
            onCopy={onCopyToClipboard}>
            <span className='g_m_left_50 g_muted icon icon-clone g_cursor_pointer' />
          </CopyToClipboard>
          {
            (txn.amount >= 0 || txn.type === 'clime_payment') &&
            <span className='icon icon-pencil g_muted g_m_left_50' onClick={onTransactionTypeUpdateClick} data-id={txn.transactionId} />
          }
          {
            copyToClipboardText === txn.transactionId &&
            <span className='g_m_left_50 g_muted'>copied</span>
          }
        </span>
      </span>
    }
    {
      txn.narration !== txn.particulars && details &&
      <span className='g_small g_muted'>{txn.particulars}</span>
    }
    {
      txn.loanId && details &&
      <span className='g_muted g_small'>Loan: {txn.loanId} {txn.loanName}</span>
    }
    {
      txn.iciciTxnId && details &&
      <span className='g_small g_muted'>Recon 733: {txn.iciciTxnId}</span>
    }
    {
      txn.currIciciTxnId && details &&
      <span className='g_small g_muted'>Recon 4412: {txn.currIciciTxnId}</span>
    }
    {/*
      txn.bankReferenceNum && !txn.particulars &&
      <span className='g_small'>
        UTR: {txn.bankReferenceNum}
      </span>
    */}
    {
      txn.type &&
      <span className='g_m_top_25'>
        <BadgeUI label={txn.typeBadge} />
        {
          txn.remitter &&
          <span className='g_m_left_50 icon icon-angle-left'> {txn.remitter}</span>
        }
        {
          txn.payee &&
          <span className='g_m_left_50 icon icon-angle-right'> {txn.payee}</span>
        }
      </span>
    }
    {
      txn.remarks &&
      <span className='g_info'>Remarks: {txn.remarks}</span>
    }
    {
      txn.tdsAmountF1 && details &&
      <span className='g_muted'>TDS {txn.tdsSection} @{txn.tdsRate}% {txn.tdsAmountF1}</span>
    }
  </div>

export default SuTransactionInnerListUI



